import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';
import { formatStatus } from 'utils/valueFormatters';
import { getShipmentBadgeColor } from 'constants/shipment';
import { TIME_OPTION } from 'constants/time';

export const getShipmentListColumns = (tenant, warehouse) => [
  {
    accessorKey: 'id',
    header: 'Shipment',
    enableSorting: true,
    meta: {
      cellProps: { className: 'py-2' },
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { order, shipment_code } = original;

      return (
        <div>
          <p className="d-flex align-items-center mb-2">
            <span className="fw-semibold me-1">Code:</span>
            <Link
              to={`${paths.orders.details(
                tenant,
                warehouse,
                order?.id,
              )}?tab=shipments`}
            >
              <strong>{shipment_code}</strong>
            </Link>
          </p>
          <p className="d-flex align-items-center mb-0">
            <span className="fw-semibold me-1">Order:</span>
            <Link
              to={`${paths.orders.details(
                tenant,
                warehouse,
                order?.id,
              )}?tab=order-items`}
            >
              <strong>{order?.channel_order_id}</strong>
            </Link>
          </p>
        </div>
      );
    },
  },
  {
    accessorKey: 'shipping_provider_type',
    header: 'Shipping Provider',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipping_provider_type } = original;

      return (
        <span>
          {shipping_provider_type ? formatStatus(shipping_provider_type) : '-'}
        </span>
      );
    },
  },
  {
    accessorKey: 'picklist',
    header: 'Picklist',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { picklist } = original;

      return <span>{picklist}</span>;
    },
  },
  {
    accessorKey: 'shipment_status',
    header: 'Shipment Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { shipment_status } = original;

      return (
        <SubtleBadge pill bg={getShipmentBadgeColor(shipment_status)}>
          {formatStatus(shipment_status)}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'invoice_code',
    header: 'Invoice Code',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { invoice_code } = original;

      return <span>{invoice_code ? invoice_code : '-'}</span>;
    },
  },
  {
    accessorKey: 'awb_number',
    header: 'AWB',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { awb_number } = original;

      return <span>{awb_number ? awb_number : '-'}</span>;
    },
  },
  {
    accessorKey: 'dispatched_date',
    header: 'Dispatched Date',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { dispatched_date } = original;

      return (
        <span>
          {dispatched_date
            ? new Date(dispatched_date).toLocaleString('en-IN', TIME_OPTION)
            : '-'}
        </span>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
];
